import { useMeasure } from "react-use";
import Widget from "../../../../../components/baseWidget";
import { useWidgetContext } from "../../../../../helpers/hooks/useWidgetContext";
import BaseChart from "../../../../../components/baseChart";
import { useMemo } from "react";

const DonutChart = ({ data, width, height }) => {
  const option = useMemo(() => {
    return {
      tooltip: {
        show: false,
      },
      legend: {
        type: "scroll",
        orient: "vertical",
        left: "60%",
        formatter: "███",
      },
      series: [
        {
          name: "██████",
          type: "pie",
          radius: ["50%", "85%"],
          right: "50%",
          width: "auto",
          height: "auto",
          formatter: "███",
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: 1048, name: "Search Engine" },
            { value: 735, name: "Direct" },
            { value: 580, name: "Email" },
            { value: 484, name: "Union Ads" },
            { value: 300, name: "Video Ads" },
          ],
        },
      ],
    };
  }, [data])
  return (
    <BaseChart
      height={height}
      width={width}
      options={option}
      chartType="donut"
    />
  );
};

const DonutWidgetSample = () => {
  const widget = useWidgetContext();
  const [ref, { width, height }] = useMeasure();
  const title = widget?.widgetData?.title;
  return (
    <Widget ref={ref}>
      <Widget.Header>
        <Widget.Title>{title}</Widget.Title>
      </Widget.Header>
      <Widget.Content>
        <DonutChart data={[]} width={width} height={height} />
      </Widget.Content>
    </Widget>
  );
};

export default DonutWidgetSample;
